<template>
  <v-row class="mx-5 my-0" cols="12" width="100%">
    <v-col cols="12">
      <v-autocomplete
        v-model="mValue.groups"
        :items="groups"
        :loading="groupsLoading"
        attach
        label="Groups"
        multiple
      />
    </v-col>
    <v-col cols="12">
      <v-autocomplete
        v-model="mValue.tags"
        :items="tags"
        :loading="tagsLoading"
        chips
        small-chips
        label="Subjects"
        multiple
      />
    </v-col>
  </v-row>
</template>

<script>
import QuilityAPI from "../../../../store/API/QuilityAPI";

export default {
  name: "MarketingResourceEditor",

  props: {
    value: { type: Object, default: () => ({}) },
  },

  data() {
    return {
      mValue: {
				groups: [],
				tags: [],
			},
      groups: [],
      tags: [],
      groupsLoading: false,
      tagsLoading: false,
    };
  },

  created () {
		const { groups = [], tags = [] } = this.value
		this.mValue = { groups, tags }
	},

  async mounted() {
    this.groupsLoading = true;
    this.groups = await QuilityAPI.getMarketingResourcesGroupsList();
    this.groupsLoading = false;
  },

  computed: {
    selectedGroups() {
      return this.mValue.groups || []
    }
  },

  watch: {
    selectedGroups: {
      async handler(newGroups) {
        this.tagsLoading = true;
        this.tags = await QuilityAPI.getMarketingResourcesTagsList(newGroups);
        this.tagsLoading = false;
      },
      immediate: true,
    },

		mValue: {
			deep: true,
			handler () {
				this.$emit('input', { ...this.value, groups: this.mValue.groups, tags: this.mValue.tags })
			},
		},

    tags() {
      this.mValue.tags = this.mValue.tags?.filter((tag) => this.tags.includes(tag)) || []
    },

    groups() {
      this.mValue.groups = this.mValue.groups?.filter((group) => this.groups.includes(group)) || []
    },
  },
}
</script>
